// extracted by mini-css-extract-plugin
module.exports = {"imgBlock":"UserImage__imgBlock___3t7fH","img":"UserImage__img___1YVoj","onlineCircle":"UserImage__onlineCircle___3tv-v"};